<template>
  <q-toolbar-title
    class="col-auto cursor-pointer"
    data-test-id="header-logo"
  >
    <div
      class="col"
      @click="currentSite.navigateToLogoRoute($router)"
    >
      <img
        alt="Logo"
        :src="$isColorDark(currentSite.headerColor) ? currentSite.lightLogoImageUrl : currentSite.darkLogoImageUrl"
        class="title-logo q-mb-sm"
        :class="{
          'title-logo-small': !$q.screen.gt.sm,
          'q-mt-md': $q.screen.gt.xs || currentSite.consumerConfig.headerType === HEADER_TYPES.DEFAULT || (!currentSite.consumerConfig.showSiteSelectorOnNavigations && !currentCircuit.supportsTranslations)
        }"
        :style="{
          'max-width': $q.screen.lt.sm ? '30vw' : undefined,
          'max-height': $q.screen.lt.sm ? '50px' : undefined,
          'height': $q.screen.lt.sm ? 'auto' : undefined
        }"
      >
    </div>
  </q-toolbar-title>
</template>

<script>
import { HEADER_TYPES } from 'src/models/site/Site'
export default {
  name: 'HeaderLogo',
  configuration: ['currentCircuit', 'currentSite'],
  created () {
    _.extend(this, { HEADER_TYPES })
  }
}
</script>
<style lang="scss" scoped>
  .title-logo {
    height: 65px;
  }
  .title-logo-small {
    height: 45px;
  }
</style>
